"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavStepper = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../TypeList/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var _excluded = ["as"];
var NavStepperElement = (0, _styledComponents["default"])(_index.TypeList).attrs({
  condensedAll: true,
  listStyleReset: true
}).withConfig({
  displayName: "NavStepper__NavStepperElement",
  componentId: "sc-m2wt0h-0"
})(["text-align:center;overflow-wrap:break-word;display:flex;flex-wrap:wrap;justify-content:center;"]);

/**
 * NavStepper is a list of steps that guide users through a process.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-navstepper--docs) |
 * [Encore site](https://encore.spotify.net/web/components/pagination#nav-stepper) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/NavStepper) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=0-682&t=OevvE6IpFUWE6egI-1)
 */
var NavStepper = exports.NavStepper = /*#__PURE__*/_react["default"].forwardRef(function NavStepper(_ref, ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'ol' : _ref$as,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(NavStepperElement, Object.assign({}, props, {
    ref: ref,
    forwardedAs: as,
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.NavStepper
  }));
});